exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-primary[data-v-280bdbd2] {\n    width: 85px;\n}\n", ""]);

// exports
